export const ZH_CN: Record<string, string> = {
  选择分析信息: '选择分析信息',
  切换指标: '切换指标',
  确定: '确定',
  取消: '取消',
  重置: '重置',
  请输入关键字搜索: '请输入关键字搜索',
  搜索: '搜索',
  恢复: '恢复',
  '已选 {} 项': '已选 {} 项',
  所选项: '所选项',
  选择下钻维度: '选择下钻维度',
  恢复默认: '恢复默认',
  搜索字段: '搜索字段',

  // switcher
  行列切换: '行列切换',
  行头: '行头',
  列头: '列头',
  值: '值',
  展开子项: '展开子项',

  // sort
  首字母: '首字母',
  手动排序: '手动排序',
  其他字段: '其他字段',
  高级排序: '高级排序',
  设置顺序: '设置顺序',
  可选字段: '可选字段',
  '按以下规则进行排序（优先级由低到高）':
    '按以下规则进行排序（优先级由低到高）',
  按: '按',
  说明: '说明：',

  // export
  复制原始数据: '复制原始数据',
  复制格式化数据: '复制格式化数据',
  下载原始数据: '下载原始数据',
  下载格式化数据: '下载格式化数据',
  操作成功: '操作成功',
  操作失败: '操作失败',

  // strategy
  时间: '时间',
  指标: '指标',
  目标值: '目标值',

  // components
  自定义颜色: '自定义颜色',
  平铺: '平铺',
  树状: '树状',
  默认: '默认',
  多彩风: '多彩风',
  简约风: '简约风',
  极简风: '极简风',
  斑马纹风: '斑马纹风',
  主题风格: '主题风格',
  类型: '类型',
  主题: '主题',
  主色系: '主色系',
  深色主题: '深色主题',
  浅色主题: '浅色主题',
  灰色: '灰色',
  自定义: '自定义',
  文字对齐: '文字对齐',
  左对齐: '左对齐',
  居中: '居中',
  右对齐: '右对齐',
  表头: '表头',
  '表身 (维度)': '表身 (维度)',
  '表身 (指标)': '表身 (指标)',
  冻结行列头: '冻结行列头',
  行: '行',
  列: '列',
  冻结行: '冻结行',
  冻结列: '冻结列',
  冻结: '冻结',
  冻结前: '冻结前',
  冻结后: '冻结后',
};
